<section class="d-flex flex-column gap-2" data-testid="billing-documents-page">
  <a
    [routerLink]="organizationLink()"
    class="back-link av-meta d-inline-flex align-items-center gap-1"
    data-testid="documents-back"
  >
    <mat-icon aria-hidden="true">arrow_back</mat-icon>
    <span>{{ 'backoffice.billing.documents.back' | translate }}</span>
  </a>

  <div class="d-flex flex-wrap align-items-center justify-content-between gap-2">
    <div class="d-flex flex-column gap-1">
      <h2 class="av-section-title m-0">{{ 'backoffice.billing.documents.title' | translate }}</h2>

      @if (facade.organizationName()) {
        <p class="cell-strong m-0" data-testid="documents-organization">
          {{ facade.organizationName() }}
        </p>
      }

      <p class="av-meta m-0">{{ 'backoffice.billing.documents.subtitle' | translate }}</p>
    </div>

    <button type="button" class="av-btn" (click)="reload()" data-testid="documents-reload">
      <mat-icon aria-hidden="true">refresh</mat-icon>
      <span>{{ 'backoffice.common.reload' | translate }}</span>
    </button>
  </div>

  <p class="av-meta m-0" data-testid="documents-scope-note">{{ 'backoffice.billing.documents.scope_note' | translate }}</p>

  @if (!facade.isOwned()) {
    <div class="av-banner p-3 d-flex align-items-start gap-2" data-testid="documents-not-owned">
      <mat-icon aria-hidden="true">report</mat-icon>
      <span>{{ 'backoffice.billing.documents.not_owned' | translate }}</span>
    </div>
  }

  @if (!facade.canMoveMoney()) {
    <div class="av-banner p-3 d-flex align-items-start gap-2" data-testid="documents-restricted">
      <mat-icon aria-hidden="true">lock</mat-icon>
      <span>{{ 'backoffice.billing.documents.money_out_restricted' | translate }}</span>
    </div>
  }
</section>

<av-dunning-panel class="mt-3"></av-dunning-panel>

<section class="av-card mt-3 d-flex flex-column" data-testid="billing-documents-body">
  <nav class="tab-bar d-flex flex-wrap" role="tablist" data-testid="billing-tabs">
    @for (tab of tabs; track tab.id) {
      <button
        type="button"
        role="tab"
        class="tab-button d-inline-flex align-items-center gap-2"
        [class.is-active]="activeTab() === tab.id"
        [attr.aria-selected]="activeTab() === tab.id"
        [attr.data-tab]="tab.id"
        (click)="selectTab(tab.id)"
      >
        <mat-icon aria-hidden="true">{{ tab.icon }}</mat-icon>
        {{ tab.label | translate }}
      </button>
    }
  </nav>

  <div class="p-4" data-testid="billing-tab-panel">
    @switch (activeTab()) {
      @case ('payments') {
        <av-payment-table></av-payment-table>
      }
      @case ('refunds') {
        <av-refund-table></av-refund-table>
      }
      @case ('credit-notes') {
        <av-credit-note-table></av-credit-note-table>
      }
      @default {
        <av-invoice-table></av-invoice-table>
      }
    }
  </div>
</section>
